import { PaymentsResponse } from "../types";
import BaseService from "./base-service";
import { RequestDto } from "./dto/request/request-dto";
import { TransactionReqDTO } from "./dto/request/transactions-request-dto";

export class TransactionService extends BaseService {
  private resource = "/api/transactions";

  async getTransactions(
    params: TransactionReqDTO,
    onSuccess: (data: PaymentsResponse) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(this.resource, params);
    await this.doGet<PaymentsResponse>(reqParams, onSuccess, onError);
  }

}